<template>
  <div @contextmenu="disableDefault" :style="{backgroundColor: cellData.data.appointmentData.color, border: bgColor}"
       style="height: 100%;" class="pa-1" :class="markDataCell(cellData)">
    <v-row class="wrap">
      <v-col>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-btn @click="emitPostCode(cellData.data.appointmentData.booking)" v-if="selectPostCode" color="blue" class="mb-2 white--text" small><v-icon>mdi-map</v-icon></v-btn>
              <p class="white--text text-truncate">
                <span v-if="cellData.data.appointmentData.booking.isApproved"><v-icon>mdi-lock</v-icon></span>
                <span v-if="cellData.data.appointmentData.booking.qcComplete"><v-icon>mdi-check</v-icon></span>
                <v-layout>
                  <v-rating
                      v-if="cellData.data.appointmentData.booking.customer.hasReviewed"
                      color="orange"
                      length="1"
                      size="10"
                      value="1"
                  ></v-rating>
                  <strong class="mt-1">{{ cellData.data.appointmentData.text }}</strong>
                </v-layout>

              </p>
              <p v-if="cellData.data.appointmentData.booking.xeroInvoiceNumber && !cellData.data.appointmentData.booking.isRepeat"
                 class="white--text text-wrap"><a style="color: white" target="_blank"
                                                  :href="cellData.data.appointmentData.booking.xeroInvoiceLink">{{ cellData.data.appointmentData.booking.xeroInvoiceNumber }}</a>
              </p>
              <p class="white--text text-wrap"><span
                  v-if="cellData.data.appointmentData.booking.customer.additionalAddress">{{ cellData.data.appointmentData.booking.customer.addPostCode }}</span>
              </p>
              <p class="white--text text-wrap"><span
                  v-if="!cellData.data.appointmentData.booking.customer.additionalAddress">{{ cellData.data.appointmentData.booking.customer.postcode }}</span>
              </p>
              <p v-if="cellData.data.appointmentData.booking.isParent && cellData.data.appointmentData.booking.selectedServices && cellData.data.appointmentData.booking.selectedServices.length > 0"
                 class="white--text">
                <strong>{{ accounting.formatMoney(cellData.data.appointmentData.booking.selectedServices[0].unitPrice, `£`, 2) }}</strong>
              </p>
              <p v-if="cellData.data.appointmentData.booking.price && !cellData.data.appointmentData.booking.isParent"
                 class="white--text"><strong>
                {{ accounting.formatMoney(cellData.data.appointmentData.booking.price, `£`, 2) }}</strong></p>
            </div>
          </template>
          <span
              v-if="cellData.data.appointmentData.booking.isParent && cellData.data.appointmentData.booking.selectedServices && cellData.data.appointmentData.booking.selectedServices.length > 0">
                  {{ accounting.formatMoney(cellData.data.appointmentData.booking.selectedServices[0].unitPrice, `£`, 2) }}</span>
          <span v-if="cellData.data.appointmentData.booking.price && !cellData.data.appointmentData.booking.isParent">
                  {{ accounting.formatMoney(cellData.data.appointmentData.booking.price, `£`, 2) }}</span>
          <span v-if="cellData.data.appointmentData.booking.isEntry">
                  {{ cellData.data.appointmentData.booking.notes }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import accounting from 'accounting';
import EventBus from "@/EventBus";

export default {
  props: {
    cellData: {
      type: Object,
      default: () => {
      }
    },
    entries: {
      type: Array,
      default: () => []
    },
    selectPostCode: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      accounting: accounting,
      bgColor: ''
    }
  },
  methods: {
    markDataCell(cellData) {
      return {
        'disable-date': cellData.data.appointmentData.booking.isEntry
      }
    },
    isHoliday(date, techId) {
      const localeDate = date.toLocaleDateString();
      return this.entries.filter(entry => {
        return new Date(entry.startDate).toLocaleDateString() === localeDate && techId === entry.techId;
      }).length > 0;
    },
    disableDefault(e) {
      e.preventDefault();
    },
    emitPostCode(booking) {
      if (booking.customer.additionalAddress) {
        EventBus.$emit("postcode", booking.customer.addPostCode);
      } else {
        EventBus.$emit("postcode", booking.customer.postcode);
      }
    }
  },
  watch: {
    cellData: {
      handler(newVal) {
        if (newVal.data.targetedAppointmentData.booking.isParent) {
          this.bgColor = '3px solid #a89932';
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
